<template>
    <div>
        <input type="hidden" :value="ValidateUbicaciones">
        <div class="form-group row mt-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="d-flex justify-content-between align-items-baseline">
                            <!-- <h4>Ubicaciones de Origen y Destino</h4> -->
                            <label class="col-form-label"><em>Los campos marcados con un * son obligatorios</em></label>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                        <h4>Origen</h4>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="TipoUbicacion" class="form-label">Tipo de Ubicación</label>
                                <input name="TipoUbicacion" id="TipoUbicacion" class="form-control"
                                    v-model="ObjOrigen.TipoUbicacion" readonly>
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="FechaSalida" class="form-label">Fecha Salida*</label>
                                <Datepicker name="FechaSalida" id="FechaSalida" v-model="ObjOrigen.FechaSalida"
                                    :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma"
                                    placeholder="0000-00-00">
                                </Datepicker>
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="HoraSalida" class="form-label">Hora Salida*</label>
                                <vue-clock-picker name="HoraSalida" id="HoraSalida" v-model="ObjOrigen.HoraSalida"
                                    :input-class="'form-control'" :done-text="'Listo'" :cancel-text="'Cancelar'"
                                    placeholder="00:00"></vue-clock-picker>
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="chkOrigen" class="form-label">Punto de partida:
                                    empr</label>
                                <div class="form-check">
                                    <input name="chkOrigen" id="chkOrigen" class="form-check-input" type="checkbox"
                                        v-model="ObjOrigen.chkOrigen" v-on:change="SetOrigenVelvet()" />
                                    <span v-if="ObjOrigen.chkOrigen">Sí</span>
                                    <span v-else>No</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="RFCRemitDestinat" class="form-label">RFC Remitente*</label>
                                <input name="RFCRemitDestinat" id="RFCRemitDestinat" type="text"
                                    v-model="ObjOrigen.RFCRemitDestinat" @input="HabilitarTribRes(ObjOrigen)"
                                    class="form-control" value="">
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                                <label for="NombreRemitDestinat" class="form-label">Nombre Remitente*</label>
                                <div class="input-group">
                                    <input name="NombreRemitDestinat" id="NombreRemitDestinat" type="text"
                                        @input="AutocompNombreEmpresa('Origen', ObjOrigen);" class="form-control ps-2"
                                        v-model="ObjOrigen.NombreRemitDestinat">
                                    <button type="button" @click="AutocompNombreEmpresa('Origen', ObjOrigen)"
                                        class="btn btn-outline-primary mb-0">
                                        <i :class="ObjOrigen.IconSearch"></i>
                                    </button>
                                </div>
                                <div class="position-relative">
                                    <ul class="busqueda list-group">
                                        <li v-for="(elem, index) in ObjOrigen.AutoCompList" :key="index"
                                            class="bss list-group-item"
                                            @click="SetDataUbicacion(elem.IdDestino, ObjOrigen)">
                                            {{ elem.Empresa }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="IDUbicacion" class="form-label">IDUbicacion</label>
                                <input name="IDUbicacion" id="IDUbicacion" type="text" class="form-control"
                                    v-model="ObjOrigen.IDUbicacion" maxlength="8" :readonly="!HabIdUbicacion">
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="NumRegIdTrib" class="form-label">N° Registro IdTributario</label>
                                <input name="NumRegIdTrib" id="NumRegIdTrib" type="text" class="form-control inict"
                                    v-model="ObjOrigen.NumRegIdTrib" :readonly="ObjOrigen.DisableNumIdTributario">
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="ResidenciaFiscal" class="form-label">Residencia Fiscal</label>
                                <select name="ResidenciaFiscal" id="ResidenciaFiscal" v-model="ObjOrigen.ResidenciaFiscal"
                                    :disabled="ObjOrigen.DisableResidenciaFiscal" class="form-control form-select">
                                    <option value="">Seleccione una opción</option>
                                    <option v-for="(elem, index) in DataInicial.pais" :key="index" :value="elem.Clave">
                                        {{ elem.Nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgCalle" class="form-label">Calle </label>
                                <input name="OrgCalle" id="OrgCalle" type="text" class="form-control"
                                    v-model="ObjOrigen.Calle">
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgNumeroExt" class="form-label">N° Ext</label>
                                <input name="OrgNumeroExt" id="OrgNumeroExt" type="text" class="form-control"
                                    v-model="ObjOrigen.NumeroExt">
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgNumeroInt" class="form-label">N° Int</label>
                                <input name="OrgNumeroInt" id="OrgNumeroInt" type="text" class="form-control"
                                    v-model="ObjOrigen.NumeroInt">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgCodigoPostal" class="form-label">Código Postal*</label>
                                <input name="OrgCodigoPostal" id="OrgCodigoPostal" type="text" class="form-control"
                                    v-model="ObjOrigen.CodigoPostal">
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgPais" class="form-label">País*</label>
                                <select name="OrgPais" id="OrgPais" class="form-control form-select"
                                    v-model="ObjOrigen.Pais" @change="GetCmbList('estado', ObjOrigen, ObjOrigen.Pais)">
                                    <option value="">Seleccione una opción</option>
                                    <option v-for="(elem, index) in DataInicial.pais" :key="index" :value="elem.Clave">
                                        {{ elem.Clave }} - {{ elem.Nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgEstado" class="form-label">Estado* </label>
                                <div class="Cascada1">
                                    <select name="OrgEstado" id="OrgEstado" class="form-control form-select"
                                        v-model="ObjOrigen.Estado"
                                        @change="GetCmbList('municipio', ObjOrigen, ObjOrigen.Estado)">
                                        <option value="">Seleccione una opción</option>
                                        <option v-for="(elem, indexEst) in ObjOrigen.ListaEstados" :key="indexEst"
                                            :value="elem.Clave"> {{ elem.Clave + ' - ' + elem.Nombre }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgMunicipio" class="form-label">Municipio</label>
                                <div class="Cascada2">
                                    <select id="OrgMunicipio" name="OrgMunicipio" class="form-control form-select"
                                        v-model="ObjOrigen.Municipio"
                                        @change="GetCmbList('colonia', ObjOrigen, ObjOrigen)">
                                        <option value="">Seleccione una opción</option>
                                        <option v-for="(elem, indexMun) in ObjOrigen.ListaMunicipios" :key="indexMun"
                                            :value="elem.Clave"> {{ elem.Clave + ' - ' + elem.Nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgColonia" class="form-label">Colonia </label>
                                <select id="OrgColonia" name="OrgColonia" class="form-control form-select"
                                    v-model="ObjOrigen.Colonia">
                                    <option value="">Seleccione una opción</option>
                                    <option v-for="(elem, indexCol) in ObjOrigen.ListaColonias" :key="indexCol"
                                        :value="elem.Clave"> {{ elem.Clave + ' - ' + elem.Nombre }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="OrgLocalidad" class="form-label">Localidad</label>
                                <select id="OrgLocalidad" name="OrgLocalidad" class="form-control form-select"
                                    v-model="ObjOrigen.Localidad">
                                    <option value="">Seleccione una opción</option>
                                    <option v-for="(elem, indexLoc) in ObjOrigen.ListaLocalidad" :key="indexLoc"
                                        :value="elem.Clave"> {{ elem.Clave + ' - ' + elem.Nombre }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <label for="OrgReferencia" class="form-label">Referencia</label>
                                <textarea name="OrgReferencia" id="OrgReferencia" class="form-control" rows="2"
                                    v-model="ObjOrigen.Referencia" maxlength="250"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="horizontal dark my-4">
                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                        <h4>Destinos y cargas</h4>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-3">
                        <button type="button" @click="AgregarDestino()" v-b-tooltip.hover.Top title="Agregar nuevo destino"
                            class="btn btn-primary"><i class="fa fa-plus-circle"></i> Agregar</button>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div v-for="(destino, index) in ListaDestinos" :key="index" class="mb-5">
                            <div id="dataUbicaciones">
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'DesTipoDestino' + index" class="form-label">Tipo de
                                                    Ubicación</label>
                                                <select :name="'DesTipoDestino' + index" :id="'DesTipoDestino' + index"
                                                    class="form-control form-select" v-model="destino.TipoDestino">
                                                    <option value="">Seleccione una opción</option>
                                                    <option value="Carga">
                                                        Carga
                                                    </option>
                                                    <option value="Destino">
                                                        Destino
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'DesFechaSalida' + index" class="form-label">Fecha
                                                    LLegada*</label>
                                                <Datepicker :name="'DesFechaSalida' + index" :id="'DesFechaSalida' + index"
                                                    v-model="destino.FechaSalida" :input-class="Setpicker.Style"
                                                    :format="Setpicker.Formato" :language="Setpicker.Idioma"
                                                    placeholder="0000-00-00"></Datepicker>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'DesHoraSalida' + index" class="form-label">Hora Llegada*</label>
                                                <vue-clock-picker :name="'DesHoraSalida' + index" :id="'DesHoraSalida' + index"
                                                    v-model="destino.HoraSalida" :input-class="'form-control'"
                                                    :done-text="'Listo'" :cancel-text="'Cancelar'"
                                                    placeholder="00:00"></vue-clock-picker>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                <label :for="'DesDistanciaRecorrida' + index" class="form-label">Distancia
                                                    Recorrida (km)</label>
                                                <input :name="'DesDistanciaRecorrida' + index" :id="'DesDistanciaRecorrida' + index"
                                                    type="text" class="form-control" v-model="destino.DistanciaRecorrida"
                                                    @input="$number_decimal($event, destino, 'DistanciaRecorrida'); CalcDistTotal()">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesRFCRemitDestinat' + index" class="form-label">RFC
                                                    Destinatario*</label>
                                                <input :name="'DesRFCRemitDestinat' + index" :id="'DesRFCRemitDestinat' + index"
                                                    type="text" @input="HabilitarTribRes(destino)" class="form-control"
                                                    v-model="destino.RFCRemitDestinat">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                                                <label :for="'DesNombreRemitDestinat' + index" class="form-label">Nombre
                                                    Destinatario</label>
                                                <div class="input-group">
                                                    <input :name="'DesNombreRemitDestinat' + index"
                                                        :id="'DesNombreRemitDestinat' + index" type="text"
                                                        @input="AutocompNombreEmpresa('Destino', destino)"
                                                        class="form-control ps-2" v-model="destino.NombreRemitDestinat">
                                                    <button type="button" @click="('Destino', destino)"
                                                        class="btn btn-outline-primary mb-0">
                                                        <i :class="destino.IconSearch"></i>
                                                    </button>
                                                </div>
                                                <div class="position-relative">
                                                    <ul class="busqueda list-group">
                                                        <li v-for="(elem, index) in destino.AutoCompList" :key="index"
                                                            @click="SetDataUbicacion(elem.IdDestino, destino)"
                                                            class="bss list-group-item">
                                                            {{ elem.Empresa }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesIDUbicacion' + index" class="form-label">IDUbicacion</label>
                                                <input :name="'DesIDUbicacion' + index" :id="'DesIDUbicacion' + index"
                                                    type="text" class="form-control" v-model="destino.IDUbicacion"
                                                    :readonly="!HabIdUbicacion" maxlength="8">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesNumRegIdTrib' + index" class="form-label">N° Registro
                                                    IdTributario</label>
                                                <input :name="'DesNumRegIdTrib' + index" :id="'DesNumRegIdTrib' + index"
                                                    type="text" class="form-control" v-model="destino.NumRegIdTrib"
                                                    :readonly="destino.DisableNumIdTributario">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesResidenciaFiscal' + index" class="form-label">Residencia
                                                    Fiscal</label>
                                                <select :name="'DesResidenciaFiscal' + index"
                                                    :id="'DesResidenciaFiscal' + index" class="form-control form-select"
                                                    v-model="destino.ResidenciaFiscal"
                                                    :disabled="destino.DisableResidenciaFiscal">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(elem, index) in DataInicial.pais" :key="index"
                                                        :value="elem.Clave">
                                                        {{ elem.Nombre }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesCalle' + index" class="form-label">Calle </label>
                                                <input :name="'DesCalle' + index" :id="'DesCalle' + index" type="text"
                                                    class="form-control" v-model="destino.Calle">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesNumeroExt' + index" class="form-label">N° Ext</label>
                                                <input :name="'DesNumeroExt' + index" :id="'DesNumeroExt' + index" type="text"
                                                    class="form-control" v-model="destino.NumeroExt">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesNumeroInt' + index" class="form-label">N° Int</label>
                                                <input :name="'DesNumeroInt' + index" :id="'DesNumeroInt' + index" type="text"
                                                    class="form-control" v-model="destino.NumeroInt">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesCodigoPostal' + index" class="form-label">Código
                                                    Postal*</label>
                                                <input :name="'DesCodigoPostal' + index" :id="'DesCodigoPostal' + index"
                                                    type="text" class="form-control" v-model="destino.CodigoPostal"
                                                    ref="cp">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesPais' + index" class="form-label">País*</label>
                                                <select :name="'DesPais' + index" :id="'DesPais' + index"
                                                    class="form-control form-select" v-model="destino.Pais"
                                                    @change="GetCmbList('estado', destino, destino.Pais)">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(elem, index) in DataInicial.pais" :key="index"
                                                        :value="elem.Clave">
                                                        {{ elem.Clave }} - {{ elem.Nombre }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesEstado' + index" class="form-label">Estado* </label>
                                                <select :name="'DesEstado' + index" :id="'DesEstado' + index"
                                                    class="form-contro form-select"
                                                    @change="GetCmbList('municipio', destino, destino.Estado)"
                                                    v-model="destino.Estado">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(elem, indexEst) in destino.ListaEstados" :key="indexEst"
                                                        :value="elem.Clave"> {{ elem.Clave + ' - ' + elem.Nombre }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesMunicipio' + index" class="form-label">Municipio</label>
                                                <select :name="'DesMunicipio' + index" :id="'DesMunicipio' + index"
                                                    class="form-control form-select" v-model="destino.Municipio"
                                                    @change="GetCmbList('colonia', destino, destino)">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(elem, indexEst) in destino.ListaMunicipios"
                                                        :key="indexEst" :value="elem.Clave"> {{ elem.Clave + ' - ' +
                                                            elem.Nombre
                                                        }}</option>
                                                </select>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesColonia' + index" class="form-label">Colonia </label>
                                                <select :name="'DesColonia' + index" :id="'DesColonia' + index"
                                                    class="form-control form-select" v-model="destino.Colonia">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(elem, indexCol) in destino.ListaColonias"
                                                        :key="indexCol" :value="elem.Clave"> {{ elem.Clave + ' - '+elem.Nombre }}</option>
                                                </select>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                <label :for="'DesLocalidad' + index" class="form-label">Localidad</label>
                                                <select :name="'DesLocalidad' + index" :id="'DesLocalidad' + index"
                                                    class="form-control form-select" v-model="destino.Localidad">
                                                    <option value="">Seleccione una opción</option>
                                                    <option v-for="(elem, indexEst) in destino.ListaLocalidad"
                                                        :key="indexEst" :value="elem.Clave"> {{ elem.Clave + ' - ' +
                                                            elem.Nombre
                                                        }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label :for="'DesReferencia' + index" class="form-label">Referencia</label>
                                                <textarea :name="'DesReferencia' + index" :id="'DesReferencia' + index"
                                                    class="form-control" v-model="destino.Referencia" rows="2"
                                                    maxlength="250"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="index >= 1" class="col-12 col-sm-12 col-md-12 col-lg-12 text-end mt-2">
                                        <button title="Borrar destino" @click="BorrarDestino(index)"
                                            type="button" class="btn btn-danger"> <i class="fa fa-trash"></i></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

const EmitEjecuta = 'seccionUbicaciones';
import Configs from '@/helpers/VarConfig.js';
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';
const SPINNER = 'spinner-border spinner-border-sm';
const MAGNIFIER = 'fa fa-search';

export default {
    name: 'FormUbicaciones',
    props: ['DataInicial', 'poBtnSave', 'pObjOrigen', 'pListaDestinos', 'pErrorvalidacion', 'pHabIdUbicacion'],
    components: {},
    data() {
        return {
            oBtnSave: {
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'routerhaciaatras',
                EmitSeccion: EmitEjecuta,
            },
            ConfigLoad: {
                ShowLoader: true,
            },
            ObjOrigen: {
                chkOrigen: false,
                TipoUbicacion: 'Origen',
                RFCRemitDestinat: '',
                FechaHoraSalidaLlegada: '',
                IDUbicacion: '',
                NombreRemitDestinat: '',
                NumRegIdTrib: '',
                ResidenciaFiscal: '',
                Calle: '',
                NumeroExt: '',
                NumeroInt: '',
                Colonia: '',
                Localidad: '',
                Referencia: '',
                Municipio: '',
                Estado: '',
                Pais: '',
                CodigoPostal: '',
                IdContacto: 0,
                // Helpers
                FechaSalida: '',
                HoraSalida: '',
                ListaEstados: [],
                ListaMunicipios: [],
                ListaColonias: [],
                ListaLocalidad: [],
                AutoCompList: [],
                IconSearch: MAGNIFIER,
                DisableNumIdTributario: true,
                DisableResidenciaFiscal: true,
            },
            ObjDestinoCarga: {
                TipoUbicacion: '',
                RFCRemitDestinat: '',
                FechaHoraSalidaLlegada: '',
                IDUbicacion: '',
                NombreRemitDestinat: '',
                NumRegIdTrib: '',
                ResidenciaFiscal: '',
                DistanciaRecorrida: '',
                Calle: '',
                NumeroExt: '',
                NumeroInt: '',
                Colonia: '',
                Localidad: '',
                Referencia: '',
                Municipio: '',
                Estado: '',
                Pais: '',
                CodigoPostal: '',
                TipoDestino: '',
                IdContacto: '',
                // Configuracion Destinos
                FechaSalida: '',
                HoraSalida: '',
                ListaEstados: [],
                ListaMunicipios: [],
                ListaColonias: [],
                ListaLocalidad: [],
                AutoCompList: [],
                IconSearch: MAGNIFIER,
                DisableNumIdTributario: true,
                DisableResidenciaFiscal: true,
            },
            // Helpers
            ListaDestinos: [],
            TimeOutSearch: null,
            Setpicker: Calendar.calendarSettings,
            isVelvetPartida: false,
            HabIdUbicacion: false,
            segurity: {},
            errorvalidacion: [],
            Emit: EmitEjecuta,
        }
    },
    methods:
    {
        // Agrega un destino vacío.
        AgregarDestino() {
            let destino = { ...this.ObjDestinoCarga }
            this.ListaDestinos.push(destino)
        },
        // Actualiza la distancia total recorrida de todos los destinos.
        CalcDistTotal() {
            let DistanciaTotal = this.ListaDestinos.reduce((acc, item) => {
                let num = parseFloat(item.DistanciaRecorrida);
                num = isNaN(num) ? 0 : num;
                return acc + num;
            }, 0);
            this.bus.$emit('UpdateDistTotal', DistanciaTotal)
        },
        // Rellena los campos de Origen con los datos de Velvet.
        SetOrigenVelvet() {
            let item = this.ObjOrigen;
            if (this.ObjOrigen.chkOrigen) {
                this.$http.get('empresas/1').then((res) => {
                    let resp = res.data.data;

                    // Asignando los valores necesarios de la respuesta al obj
                    item.NombreRemitDestinat = resp.RazonSocial;
                    item.RFCRemitDestinat = resp.Rfc;
                    item.IdContacto = resp.IdEmpresa;
                    item.Calle = resp.Calle;
                    item.NumeroExt = resp.NoExt;
                    item.NumeroInt = resp.NoInt;
                    item.CodigoPostal = resp.Cp;
                    item.Pais = 'MEX';
                    item.Estado = resp.IdEstado;
                    item.Municipio = resp.IdMunicipio;
                    item.Colonia = resp.Colonia;
                    item.Localidad = resp.Localidad;
                    item.Referencia = resp.Referencias;
                    this.$http.get("cpDataCombosUbicacion", {
                        params: {
                            Pais: item.Pais,
                            IdEstado: item.Estado,
                            IdMunicipio: item.Municipio,
                        }
                    }).then((res) => {
                        item.ListaEstados = res.data.data.ListEstado;
                        item.ListaMunicipios = res.data.data.ListMunicipio;
                        item.ListaLocalidad = res.data.data.ListLocalidad;
                        item.ListaColonias = res.data.data.ListColonia;
                    }).catch(err => console.error(err));
                })
            } else {
                // Vacia la informacion de direccion en el origen
                item.NombreRemitDestinat = "";
                item.RFCRemitDestinat = "";
                item.IdContacto = 0;
                item.Calle = "";
                item.NumeroExt = "";
                item.NumeroInt = "";
                item.CodigoPostal = "";
                item.Pais = "";
                item.Estado = "";
                item.Municipio = "";
                item.Colonia = "";
                item.Localidad = "";
                item.Referencia = "";
                this.GetCmbList('estado', this.ObjOrigen, '')
            }
        },
        // Habilita o deshabilita los campos de N° Registro IdTributario y Residencia Fiscal en donde fue llamada la funcion
        HabilitarTribRes(item) {
            // SI EL RFC ES GENERICO EXTRANJERO == XEXX010101000, SE HABILITA
            if (item.RFCRemitDestinat == 'XEXX010101000') {
                item.DisableNumIdTributario = false;
                item.DisableResidenciaFiscal = false;
            } else {
                item.DisableNumIdTributario = true;
                item.NumRegIdTrib = '';
                item.DisableResidenciaFiscal = true;
                item.ResidenciaFiscal = '';
            }
        },
        // Autocompletado para Nombre Destinatario en los destinos.
        AutocompNombreEmpresa(Lugar, item) {
            clearTimeout(this.TimeOutSearch);
            this.TimeOutSearch = setTimeout(() => {
                this.BuscarNombreEmpresa(Lugar, item);
            }, 750);
        },
        // Recupera la lista de empresas coincidentes con la busqueda.
        BuscarNombreEmpresa(Lugar, item) {
            const MINLENGTH = 0;
            let IdInstitucion = this.DataInicial.IdInstitucion;
            if (item.NombreRemitDestinat.length > MINLENGTH && true) {
                item.IconSearch = SPINNER;
                let params = {
                    // IdCliente: '1CRMINS504',
                    // IdCliente: IdInstitucion,
                    TipoDestino: Lugar,
                    TxtBusqueda: item.NombreRemitDestinat,
                }
                this.$http.get('cpAutcompDestinos', {
                    params: {
                        TipoDestino: Lugar,
                        TxtBusqueda: item.NombreRemitDestinat,
                    }
                }).then((res) => {
                    item.AutoCompList = res.data.data
                }).finally(() => {
                    item.IconSearch = MAGNIFIER;
                })
            } else {
                item.AutoCompList = [];
            }
        },
        // Rellena los el Obj destino indicado con la data recuperada.
        SetDataUbicacion(Id, item) {
            this.$http.get('cpDestinos/' + Id,).then((res) => {
                let resp = res.data.data;

                // Asignando los valores necesarios de la respuesta al obj.
                item.RFCRemitDestinat = resp.RFC;
                item.NombreRemitDestinat = resp.Empresa;
                item.NumeroExt = resp.NumExt;
                item.NumeroInt = resp.NumInt;
                item.Referencia = resp.Referencias;
                item.IdContacto = resp.IdDestino;
                // Propiedades que coinciden.
                let keys = ['Calle', 'Pais', 'Estado', 'CodigoPostal', 'Municipio', 'Colonia', 'Localidad', 'ListaEstados', 'ListaMunicipios', 'ListaColonias', 'ListaLocalidad'];
                keys.forEach(elem => {
                    if (resp[elem]) {
                        item[elem] = resp[elem];
                    }
                })
                this.$http.get("cpDataCombosUbicacion", {
                    params: {
                        Pais: item.Pais,
                        Estado: item.Estado,
                        Municipio: item.Municipio,
                    }
                }).then((res) => {
                    item.ListaEstados = res.data.data.ListEstado;
                    item.ListaMunicipios = res.data.data.ListMunicipio;
                    item.ListaLocalidad = res.data.data.ListLocalidad;
                    item.ListaColonias = res.data.data.ListColonia;
                }).catch(err => console.error(err));

            }).finally(() => {
                this.HabilitarTribRes(item);
                if (item.hasOwnProperty('chkOrigen')) [
                    item.chkOrigen = false,
                ]
                item.AutoCompList = []
            });
        },
        // Borra el destino indicado
        BorrarDestino(Id) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    this.ListaDestinos.splice(Id, 1)
                    this.CalcDistTotal();
                }
            });
        },
        Limpiar() {
            this.ObjOrigen = {
                chkOrigen: false,
                TipoUbicacion: 'Origen',
                RFCRemitDestinat: '',
                FechaHoraSalidaLlegada: '',
                IDUbicacion: '',
                NombreRemitDestinat: '',
                NumRegIdTrib: '',
                ResidenciaFiscal: '',
                Calle: '',
                NumeroExt: '',
                NumeroInt: '',
                Colonia: '',
                Localidad: '',
                Referencia: '',
                Municipio: '',
                Estado: '',
                Pais: '',
                CodigoPostal: '',
                IdContacto: 0,
                // Helpers
                FechaSalida: '',
                HoraSalida: '',
                ListaEstados: [],
                ListaMunicipios: [],
                ListaColonias: [],
                ListaLocalidad: [],
                AutoCompList: [],
                IconSearch: MAGNIFIER,
                DisableNumIdTributario: true,
                DisableResidenciaFiscal: true,
            };
            this.isVelvetPartida = false;
            this.HabIdUbicacion = false;
            this.ListaDestinos = [];
            this.errorvalidacion = [];
        },
        // Rellena los combos select para Estado, Municipio, Colonia y Localidad.
        GetCmbList(Tipo, Item, Criterio) {
            const sinCriterio = Criterio == '';

            switch (Tipo) {
                case 'estado':
                    Item.ListaEstados = [];
                    sinCriterio ? Item.ListaEstados = [] : this.DataInicial.getComboList(Item.ListaEstados, Tipo, Criterio, this);
                    Item.ListaMunicipios = [];
                    Item.ListaLocalidad = [];
                    Item.ListaColonias = [];
                    Item.Estado = '';
                    Item.Municipio = '';
                    Item.Localidad = '';
                    Item.Colonia = '';
                    break;

                case 'municipio':
                    Item.ListaMunicipios = [];
                    Item.ListaLocalidad = [];
                    if (!sinCriterio) {
                        this.DataInicial.getComboList(Item.ListaMunicipios, Tipo, Criterio, this);
                        this.DataInicial.getComboList(Item.ListaLocalidad, 'localidad', Criterio, this);
                    }
                    Item.ListaColonias = [];
                    Item.Municipio = '';
                    Item.Localidad = '';
                    Item.Colonia = '';
                    break;

                case 'colonia':
                    Item.ListaColonias = [];
                    sinCriterio ? Item.ListaColonias = [] : this.DataInicial.getComboList(Item.ListaColonias, Tipo, Criterio, this);
                    Item.Colonia = '';
                    break;

                case 'localidad':
                    Item.ListaLocalidad = [];
                    sinCriterio ? Item.ListaLocalidad = [] : this.DataInicial.getComboList(Item.ListaLocalidad, Tipo, Criterio, this);
                    Item.Colonia = '';
                    break;
            }
        },
        SetearDataRecov() {
            if (this.pObjOrigen.NombreRemitDestinat) {
                Object.assign(this.ObjOrigen, this.pObjOrigen);
                this.HabilitarTribRes(this.ObjOrigen);
                if (this.pObjOrigen.TipoDestino === 'empr') {
                    this.ObjOrigen.chkOrigen = true;
                }
                if(this.ObjOrigen.FechaHoraSalidaLlegada){
                    let FechaHora = this.ObjOrigen.FechaHoraSalidaLlegada.split(" ");
                    let FechaFormat = FechaHora[0].replace(/-/g,'\/');
                    this.ObjOrigen.FechaSalida = new Date(FechaFormat);
                    this.ObjOrigen.HoraSalida = FechaHora[1];
                }
                this.ObjOrigen.Municipio = this.ObjOrigen.Municipio ?? '';
                this.ObjOrigen.Colonia = this.ObjOrigen.Colonia ?? '';
                this.ObjOrigen.Localidad = this.ObjOrigen.Localidad ?? '';

                this.$http.get("cpDataCombosUbicacion",{
                        params:{
                            Pais:this.ObjOrigen.Pais,
                            Estado:this.ObjOrigen.Estado,
                            Municipio:this.ObjOrigen.Municipio,
                        }
                    }).then((res)=>{
                        this.ObjOrigen.ListaEstados = res.data.data.ListEstado;
                        this.ObjOrigen.ListaMunicipios = res.data.data.ListMunicipio;
                        this.ObjOrigen.ListaLocalidades = res.data.data.ListLocalidad;
                        this.ObjOrigen.ListaColonias = res.data.data.ListColonia;
                    }).catch(err => console.error(err));       
            }
            if (this.pListaDestinos.length >= 1) {
               this.pListaDestinos.forEach(destino => {
                    let newDestino = JSON.parse(JSON.stringify(this.ObjDestinoCarga));
                    this.ListaDestinos.push(newDestino)
                    let targetDestino = this.ListaDestinos[this.ListaDestinos.length-1];
                    // targetDestino.RFCRemitDestinat = destino.RFCRemitDestinat;
                    Object.assign(targetDestino, destino);
                    this.HabilitarTribRes(targetDestino);
                    let FechaHora = targetDestino.FechaHoraSalidaLlegada.split(" ");
                    let FechaFormat = FechaHora[0].replace(/-/g,'\/');
                    targetDestino.FechaSalida = new Date(FechaFormat);
                    targetDestino.HoraSalida = FechaHora[1];
                    this.$http.get("cpDataCombosUbicacion",{
                        params:{
                            Pais:targetDestino.Pais,
                            Estado:targetDestino.Estado,
                            Municipio:targetDestino.Municipio,
                        }
                    }).then((res)=>{
                        targetDestino.ListaEstados = res.data.data.ListEstado;
                        targetDestino.ListaMunicipios = res.data.data.ListMunicipio;
                        targetDestino.ListaLocalidades = res.data.data.ListLocalidad;
                        targetDestino.ListaColonias = res.data.data.ListColonia;
                    }).catch(err => console.error(err));                
                })
            }
            this.CalcDistTotal();
        },
    },
    computed: {
        ValidateUbicaciones() {
            if (this.pErrorvalidacion != undefined) {
                this.errorvalidacion = this.pErrorvalidacion;
            }
            if (this.pHabIdUbicacion != this.HabIdUbicacion) {
                this.HabIdUbicacion = this.pHabIdUbicacion;
            }
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        this.SetearDataRecov();
    }
}
</script>
